import {DRAWER_PORTAL} from './portalIds';
import {usePortalElement} from './usePortalElement';

export function useDrawerPortalElement() {
  return usePortalElement(DRAWER_PORTAL);
}
